import React, { Component } from "react";
import { Row, Col, Form, FormGroup, Label, Button } from "reactstrap";
import Alert from "react-s-alert";
import _ from "lodash";

import { api } from "../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            forgotPassword: false,
            forgotPasswordEmail: "",
            sendingEmail: false
        };

        this.login = this.login.bind(this);
        this.toggleForgotPassword = this.toggleForgotPassword.bind(this);
        this.sendResetPasswordEmail = this.sendResetPasswordEmail.bind(this);
    }

    login(e) {
        e.preventDefault();
        const errorMessage = "There was an error logging in";
      this.setState({ sendingEmail: true }, () => {
        api
          .post("authenticate", {
            Email: this.state.email,
            Password: this.state.password
          })
          .then(response => {
            if (response.data.result === null) {
              if (response.data.errorMessages) {
                Alert.error(response.data.errorMessages.join('<br/>'));
              }
              else {
                Alert.error(errorMessage);
              }
              this.setState({ sendingEmail: false })
            } else {
              this.props.setCurrentUser(response.data.result);
            }
          })
          .catch(err => Alert.error(errorMessage));
      });
    }

    toggleForgotPassword() {
        this.setState(prevState => { return { forgotPassword: !prevState.forgotPassword } })
    }

    sendResetPasswordEmail() {
        const errorMessage = "There was an error sending the password reset email";
        this.setState({ sendingEmail: true }, () => {
            const trimmedEmail = _.trim(this.state.forgotPasswordEmail);
            if (!trimmedEmail) {
                Alert.warning("Email must not be blank");
                return;
            }
            api.post("sendresetemail", {
                Email: trimmedEmail
            }).then(response => {
                if (response.data) {
                    Alert.success("Reset email sent");
                    this.setState({ 
                        forgotPassword: false, 
                        forgotPasswordEmail: "",
                        sendingEmail: false});
                } else {
                    this.setState({ sendingEmail: false })
                    Alert.error(errorMessage);
                }
            }).catch(error => {
                this.setState({ sendingEmail: false })
                Alert.error(errorMessage);
            });
        })
    }

    render() {
        return (
            <Form onSubmit={this.login} className="p-2">
                <Row>
                    <Col xs={6} md={3}>
                        <FormGroup>
                            <Label>Email:</Label>
                            <input
                                className="form-control"
                                value={this.state.email}
                                onChange={e => this.setState({ email: e.target.value })}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} md={3}>
                        <FormGroup>
                            <Label>Password:</Label>
                            <input
                                type="password"
                                className="form-control"
                                value={this.state.password}
                                onChange={e => this.setState({ password: e.target.value })}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="expand-md">
                    <Col xs={6} md={3} className="text-right justify-content-end">
                        <button className="btn btn-primary" type="submit" value="Log On">
                            Log On
                        </button>
                    </Col>
                </Row>
                {!this.state.forgotPassword &&
                <Row>
                    <Col xs={8} md={3}>
                        <Button style={{paddingLeft: 0}} onClick={this.toggleForgotPassword}
                                color="link">Reset password</Button>
                    </Col>
                </Row>
                }
                {this.state.forgotPassword &&
                <React.Fragment>
                    <Row>
                        <Col xs={6} md={3}>
                            <FormGroup>
                                <Label>Email:</Label>
                                <input
                                    name="forgotpasswordemail"
                                    className="form-control"
                                    value={this.state.forgotPasswordEmail}
                                    onChange={e => this.setState({ forgotPasswordEmail: e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row >
                        <Col xs={6} md={3} className="text-right">
                            {this.state.sendingEmail ?
                                <FontAwesomeIcon icon="spinner" size="lg" spin/>
                                :
                                <Button
                                    color="success"
                                    onClick={this.sendResetPasswordEmail}
                                >
                                    Submit
                                </Button>
                            }
                        </Col>
                    </Row>
                </React.Fragment>
                }
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Login.js